// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","primary":"#56CCF2","textDefault":"#808080","wrapper":"_1g0cOcYkiFYk10lOkgQ3L0","container":"_15HjCANorjbvYTSfd52W9A","row":"_2biXC3ySNf9lFgIQI5p7Sp","cell":"_3B9jwdRooNauVq3ScBrdie","title-cell":"omJX_2GGPx69kldaxTdKT","criterion":"p89rX40eb5hcLYk4Nk2ZK","criterion-title":"_1vnQ_rUTHns0K920Va6h-f","progress-title":"_1hYPwCjly19GtrQRgtcBFs","value":"_1uMCMZ8-SawVozvUHLxIXO","column":"_2hOk8Toa8wg0tB33nOV1cv","value-cell":"_3oiXF11hsVjhN2tNCy4b8x","mob-container":"_2CaUlWDQpRLVXoV9saeKIr","hidden":"_2_-nQ8s3jRVKJ7ChqxcsCx"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RecoveryPlan/components/ValuesChart.mod.css
// module id = 2127
// module chunks = 0